export default __webpack_public_path__ + "static/media/photo.762ae8d0.jpg";